import { ReactNode } from 'react'
import Grid from '@mui/material/Grid2'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import SyncIcon from '@mui/icons-material/Sync'

import ColumnSelector from './ColumnSelector'
import useStyles from './styles'
import { useDataManager } from './DataManager'
import COLORS from 'lib/colors'

export type ComponentTableAction = {
  icon?: never
  tooltip?: never
  onClick?: never
  component: () => JSX.Element
}

export type IconTableAction = {
  icon: string | ReactNode | (() => ReactNode)
  tooltip: string
  onClick: (e: React.MouseEvent) => void
  component?: never
}

export type TableAction = ComponentTableAction | IconTableAction

export type SweetTableTitleProps = {
  title?: string
  columnsButton?: boolean
  refreshButton?: boolean
  refresh?: () => void
  actions?: TableAction[]
  children?: React.ReactNode
}

function Action({ action }: { action: TableAction }) {
  const classes = useStyles()

  if(action.component) {
    return <action.component/>
  }

  return (
    <Tooltip title={action.tooltip}>
      <IconButton onClick={action.onClick} size="large" sx={{ color: COLORS.frenchBlue }}>
        <>
          {typeof(action.icon) === 'string' && (
            <img src={action.icon} className={classes.actionIcon}/>
          ) ||
            typeof(action.icon) === 'function' && (
            action.icon()
          ) || (
            action.icon
          )}
        </>
      </IconButton>
    </Tooltip>
  )
}

export default function SweetTableTitle({title, columnsButton=false, refreshButton=false, refresh, actions=[], children = null}: SweetTableTitleProps) {
  const classes = useStyles()
  const dataManager = useDataManager()

  if(title || columnsButton || refreshButton || actions.length) {
    return (
      <>
      {children && (
        <Grid container direction="row" justifyContent="space-between" alignItems="center" className={classes.title}>
          <Grid>
            {title && (
              <Typography variant="h2">{title}</Typography>
            )}
          </Grid>
        </Grid>
      )}

      <Grid container direction="row" justifyContent="space-between" alignItems="center" className={classes.title} role="heading" aria-roledescription="Table Title" aria-label={title}>
        <Grid className={classes.titleChildren}>
          {children ? (
            children
          ) : (title && (
            <Typography variant="h2">{title}</Typography>
          ))}
        </Grid>
        <Grid>
          {actions.map((action, index) => (
            <Action action={action} key={index}/>
          ))}
          {columnsButton && (
            <ColumnSelector/>
          )}
          {refreshButton &&
            <Tooltip title="Refresh">
              <IconButton aria-label="Refresh" onClick={() => refresh ? refresh() : dataManager.reload()} sx={{ marginLeft: '0 !important', color: COLORS.frenchBlue }} >
                <SyncIcon style={{ transform: 'rotate(45deg)' }} />
              </IconButton>
            </Tooltip>
          }
        </Grid>
      </Grid>
      </>
    )
  } else {
    return null
  }
}
